"use client"
import { useState } from "react"
import "./CareerPart.css"

const CareersMean = () => {
  const [activeTab, setActiveTab] = useState("impact")

  const tabs = [
    { id: "belong", label: "TRANSPARENCY" },
    { id: "purpose", label: "BELONGING" },
    { id: "impact", label: "FLEXIBILITY" },
    { id: "growth", label: "GROWTH" },
  ]

  const tabContent = {
    belong: {
      title: "TRANSPARENCY",
      icon: "/time.webp",
      description:
        "The company is transparent about salaries and performance expectations, so you know where you are and where you can go. We have a career development plan that helps you progress, and we all know the company's goals and strategies. Our management team meets with us to give biannual performance feedback, and promotions are automatic if you hit the targets, helping you establish and reach your next milestone. All you have to do is bring your best game to the table.",
    },
    purpose: {
      title: "BELONGING",
      icon: "/belonging.svg",
      description:
        "We've got your back. Our People Experience Partners meet with you monthly to listen to your concerns, support you, and ensure you know you can evolve and be proud of your work. Your feedback helps us improve as a team. And when your workplace recognises your successes, you'll never want to leave. And we're always celebrating together as a community, so we've got lots to look forward to!",
    },
    impact: {
      title: "FLEXIBILITY",
      icon: "/flexibilty.webp",
      description:
        "We love what we do and how we help our clients build the future. We are remote-first, allowing people to work from wherever they need to, and we want to help you balance work with your other goals. And we promote flexible work schedules and hate overtime. In exchange, we want you to be passionate about your work, dedicated, and autonomous and will go above and beyond to help us succeed.",
    },
    growth: {
      title: "GROWTH",
      icon: "/growth.png",
      description:
        "We work with dozens of new clients yearly so that you can apply your skills across different industries and never get bored. And our career plan rewards ongoing development. You're constantly learning through sharing and learning sessions. We're always innovative and hard-working - so if that sounds like you, join us!",
    },
  }

  return (
    <section className="careers-mean-section" id="values">
      <div className="container">

      <div className="title-row">
        <h2>
          HOW DOES IT FEEL TO BE PART OF <br />
          <span>‍LATTICE LABS?</span>
        </h2>
        
      </div>

      <div className="tab-card">
        <div className="tabs">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </div>
          ))}
        </div>

        <div className="tab-content">
          <img src={tabContent[activeTab].icon} alt="icon" />
          <h3>{tabContent[activeTab].title}</h3>
          <p>{tabContent[activeTab].description}</p>
        </div>
      </div>
      </div>
      
    </section>
  )
}

export default CareersMean
